import React from 'react';
import { useSelector } from 'react-redux';

import { userRoles } from 'constants/users';
import { Button } from 'components/Button/RoundButton';
import { HeadingContainer, Header, RightHeadingContainer, DescriptionHeading, CustomTestHeading, Link } from './styles';

export default function PageTitleHeader({ type }) {
  const { userRole, isCommunityUser } = useSelector((state) => state.auth);

  return (
    <HeadingContainer>
      <Header>{type === 'challenges' ? 'Challenges' : type === 'courses' ? 'Courses' : 'Exercises'}</Header>
      <RightHeadingContainer>
        <DescriptionHeading>
          {type === 'challenges'
            ? 'Compete against the community to ascend the leaderboard'
            : type === 'courses'
              ? 'Learn the coding by solving exercises'
              : 'Practice your coding skills by solving exercises'}
        </DescriptionHeading>
        <CustomTestHeading>
          {type !== 'courses' && userRole === userRoles.CANDIDATE && isCommunityUser && (
            <Link to="/customTests">
              <Button
                primaryBlue
                primaryGreenBorder
                title={'Create your own ' + (type === 'challenges' ? 'challenge' : 'exercise')}
              >
                <i className="fa fa-plus">&nbsp;</i>Create
              </Button>
            </Link>
          )}
        </CustomTestHeading>
      </RightHeadingContainer>
    </HeadingContainer>
  );
}
